import axios from "axios";

/* const env = window._env_ || {};
const backendIp = env.REACT_APP_BACKEND_IP || "localhost";
const backendPort = env.REACT_APP_BACKEND_PORT || "8080"; */

/* const api = axios.create({
  baseURL: "http://localhost:8080/api",
  headers: {
    "Content-Type": "application/json",
  },
});
 */

const backendUrl =
  process.env.NODE_ENV === "development" ? "http://localhost:8080/api" : "/api";

const api = axios.create({
  baseURL: backendUrl,
  withCredentials: true,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("SkeyegateAuthToken");
    if (config.url !== "/auth/login") {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

let isRefreshing = false;

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response?.status === 401 &&
      error.config?.url !== "/auth/refresh-token"
    ) {
      if (!isRefreshing) {
        isRefreshing = true;
        localStorage.removeItem("SkeyegateAuthToken");
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  },
);

export default api;
